import { Flex } from '@backend/lib-design-system';
import { styled } from 'styled-components';

import { SearchButton } from '~/components/SearchButton';
import { palette } from '~/themes/default';
import { tabletAndMobileOnlyMixin } from '~/utils/mixins';
import { getMediaQuery } from '~/utils/responsive/media';

export const FiltersPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${getMediaQuery('mobile', 'tablet')} {
    width: 100%;
  }
`;

export const FiltersHeaderContainer = styled(Flex.Column)`
  background-color: ${({ theme }) => theme.palette.blue50};
  border-radius: ${({ theme }) => theme.radiuses.xl};
  color: ${palette.darkBlue};
  min-width: 100%;

  ${getMediaQuery('laptop', 'desktop')} {
    width: 20rem;
  }

  & > div:not(:last-of-type) {
    padding-bottom: 1rem;
  }
  padding: 0.75rem 2rem;
  ${tabletAndMobileOnlyMixin}
  button {
    padding: 0;
  }
`;

export const FiltersAndSearchButtonContainer = styled.div<{ showFiltersPanelForm: boolean }>`
  position: relative;
  padding: 1.5rem 2rem;

  ${getMediaQuery('mobile', 'tablet')} {
    display: ${({ showFiltersPanelForm }) => (showFiltersPanelForm ? 'block' : 'none')};
  }

  background-color: ${({ theme }) => theme.palette.blue50};
  border-radius: ${({ theme }) => theme.radiuses.xl};
  color: ${palette.darkBlue};
  min-width: 100%;

  ${getMediaQuery('laptop', 'desktop')} {
    width: 20rem;
  }
`;

export const FiltersContainer = styled.div`
  width: 100%;
`;

export const FiltersAddressAndJobFieldsContainer = styled.div<{ $isIframe: boolean }>`
  ${getMediaQuery('tablet', 'laptop', 'desktop')} {
    display: ${({ $isIframe }) => ($isIframe ? 'block' : 'none')};
  }
`;

export const CustomSearchButton = styled(SearchButton)`
  top: 50%;
  right: -0.5rem;
  position: absolute;
  z-index: 9999;
  transform: translateY(-50%);
  ${tabletAndMobileOnlyMixin}
`;

export const Label = styled.label`
  display: block;
  font-family: ${({ theme }) => theme.typography.fontFamily.regular};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;

export const FilterLabel = styled(Label)`
  padding-left: 1.75rem;
  padding-bottom: 0.5rem;
`;

export const FilterFieldContainer = styled.div`
  padding: 0.5rem 0.5rem 0;
  margin-bottom: 1rem;
`;

export const HeaderTitle = styled(Label)`
  text-transform: uppercase;
`;

export const Text = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily.regular};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  font-size: ${({ theme }) => theme.typography.fontSize.s};
`;
